module.exports = __webpack_public_path__ + "img/login-bg.57ccbb2a.jpg";